import { render, staticRenderFns } from "./d-post-image.vue?vue&type=template&id=3c54676c&scoped=true&"
import script from "./d-post-image.vue?vue&type=script&lang=js&"
export * from "./d-post-image.vue?vue&type=script&lang=js&"
import style0 from "./d-post-image.vue?vue&type=style&index=0&id=3c54676c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c54676c",
  null
  
)

export default component.exports